import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    main: "#365CA5",
  },
});

export default theme;
